import { IAuthenticationRepository } from '../domain/IAuthenticationRepository'

export class GetUserRoles {
  constructor(private readonly authenticationRepository: IAuthenticationRepository) {}

  async execute(): Promise<string[]> {
    return this.authenticationRepository.getRoles()
  }
}
